import AIIcon from '@cobliteam/ai/src/ui/AIIcon';
import type { IconNames } from '@cobliteam/ui/icons';
import { BlocksIcon } from './blocks';
import { CircleHelpIcon } from './circle-help';
import { FileChartColumnIncreasingIcon } from './file-chart-column-increasing';
import { FileChartLineIcon } from './file-chart-line';
import { GiftIcon } from './gift';
import { HomeIcon } from './home';
import { MapIcon } from './map';
import { PaletteIcon } from './palette';
import { SettingsGearIcon } from './settings-gear';
import { ShieldCheckIcon } from './shield-check';
import { TrendingUpIcon } from './trending-up';
import { TruckIcon } from './truck';

const getAnimatedIcon = ({ icon, isHovered }: { icon: IconNames; isHovered: boolean }) => {
  const iconsMap = {
    sparkles: <AIIcon size={18} isHovered={isHovered} className='text-gray-11' />,
    blocks: <BlocksIcon size={18} isHovered={isHovered} />,
    'circle-help': <CircleHelpIcon size={18} isHovered={isHovered} />,
    house: <HomeIcon size={18} isHovered={isHovered} />,
    'file-text': <FileChartLineIcon size={18} isHovered={isHovered} />,
    map: <MapIcon size={18} isHovered={isHovered} />,
    palette: <PaletteIcon size={18} isHovered={isHovered} />,
    settings: <SettingsGearIcon size={18} isHovered={isHovered} />,
    'shield-alert': <ShieldCheckIcon size={18} isHovered={isHovered} />,
    'trending-up': <TrendingUpIcon size={18} isHovered={isHovered} />,
    truck: <TruckIcon size={18} isHovered={isHovered} />,
    'file-chart-column-increasing': <FileChartColumnIncreasingIcon size={18} isHovered={isHovered} />,
    gift: <GiftIcon size={18} isHovered={isHovered} />,
  };

  return iconsMap[icon as keyof typeof iconsMap] ?? null;
};

export { getAnimatedIcon };
